<template>
  <div class="item">
    <span class="content" v-show="!hideName">{{ name }}</span>
    <div class="number" style="width: 100px; margin-left: 10px;">
      <input
        type="number"
        min="0"
        class="input"
        :placeholder="placeholder"
        :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="save"
      />
      <span class="content unit">{{unit}}</span>
    </div>

    <a class="save" v-show="saveIconStatus" @click="save()"
      ><font-awesome-icon icon="save"
    /></a>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon
  },
  props: {
    code: String,
    name: String,
    value: [String, Number],
    placeholder: String,
    dbTable: String,
    remark: String,
    dtype: {
      type: String,
      default: function() {
        return "text";
      }
    },
    unit: {
      type: String,
      default: function() {
        return this.$t("EditBoxInputTime.Minutes")
      }
    },
    hideName: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  data() {
    return {
      originValue: "",
      type: "string"
    };
  },
  created() {
    this.originValue = this.value;
  },
  computed: {
    saveIconStatus() {
      return this.value !== this.originValue;
    }
  },
  methods: {
    save: function() {
      console.log("save");
      if (this.value !== this.originValue) {
        this.originValue = this.value;
        this.$emit("update-input", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.value,
          origin: this.originValue,
          type: this.type,
          warning: this.saveIconStatus
        });
      }
    },
    emitEditStatusEventToParent() {
      console.log("savedEventToParent in!!!")
      let changeStatusData = {
        code: this.code,
        warning: this.saveIconStatus
      };
      this.$emit('change-edit-status', changeStatusData)
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      return newVal;
    },
    saveIconStatus: function(newVal, oldVal) {
      console.log("saveIconStatus: ", newVal, oldVal)
      this.emitEditStatusEventToParent();
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
